<template>
  <Shell
    logo-src="/campus_logo.svg"
    logo-alt="Campus"
    :user="userStore.currentUser"
    :show-blur-toggle="isGuide"
    :is-blurred="isBlurred"
    @toggle-blur="toggleBlur"
    @logout="handleLogout"
  >
    <template #sidebar>
      <SidebarMenu />
    </template>
    <div class="flex-grow">
      <GraduationBanner />
      <router-view />
    </div>
  </Shell>
</template>

<script setup lang="ts">
import { Shell } from '@outtalent-dev/shared'
import SidebarMenu from '@/components/layout/SidebarMenu.vue'
import GraduationBanner from '@/components/common/GraduationBanner.vue'
import { onMounted } from 'vue'
import { useAuth } from '@/composables/useAuth'
import { usePrivacyMode } from '@/composables/usePrivacyMode'
import { useUserStore } from '@/stores/user'
import { useRouter } from 'vue-router'

const { isGuide } = useAuth()
const { isBlurred, toggleBlur } = usePrivacyMode()
const userStore = useUserStore()
const router = useRouter()

const handleLogout = async () => {
  await userStore.logout()
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  router.push('/login')
}

onMounted(async () => {
  if (!userStore.currentUser) {
    await userStore.fetchCurrentUser()
  }
})
</script>
